import React from 'react';

import StringUtils from '../../../common/utils/StringUtils';

import DataItemView from '../../../common/view/DataItemView';

export default class CounterpartyTile extends DataItemView {
  static displayName = CounterpartyTile.name;

  constructor(props) {
    super(props);

    this.bindDataItem(props.counterparty);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.counterparty);
  }

  render() {
    if (!this.state.isDataBound)
      return (<div />);

    return (
      <div className={this.getCounterpartyTileClassNames(this.state.isDeleted)}>
        <div>
          <span className="pwx-tile-identifier">{this.getdisplayValue(this.state.code, 'CODE')}</span>
          <span>&nbsp;</span>
          <span className="pwx-modified-flag dx-icon-rename" hidden={!this.state.groupIsModified} />
          <span className="pwx-error-flag dx-icon-warning" hidden={!this.state.groupHasErrors} />
          <span className="pwx-update-flag dx-icon-clear" hidden={!StringUtils.isNonEmptyString(this.state.updateErrorMessage)} title={this.state.updateErrorMessage} />
        </div>
        <div className="pwx-tile-long-name">{this.getdisplayValue(this.state.displayName, 'DISPLAY NAME')}</div>
      </div>
    );
  }

  getCounterpartyTileClassNames(isDeleted) {
    var classNames = 'pwx-tile';
    if (isDeleted)
      classNames += ' pwx-tile-deleted';

    return classNames;
  }

  getdisplayValue(value, placeholder) {
    return StringUtils.isNonEmptyString(value)
      ? value
      : `[${placeholder}]`;
  }
}